import { Fragment } from "react"
import classNames from "classnames"

import { useTranslation } from "lib/i18n/translation"
import { useMainCategories } from "lib/tools/categories"

import SkeletonLink from "components/common/skeleton-link"

export const Recommenders = ({ product: { recommendersIds = [] }, loading }) => {
	const { c } = useTranslation("common")
	const { allLists } = useMainCategories()

	if (recommendersIds.length === 0) {
		return null
	}

	const recommenders = recommendersIds
		.map(id => allLists.find(l => l.director.id == id))
		.filter(l => !!l)

	return (
		<section className="short">
			<p
				className={classNames(
					"is-recommended",
					{
						"skeleton": loading
					}
				)}
			>
				<b>{c("recommended-by")}</b>
				{recommenders.map((list, index) => (
					<Fragment key={index}>
						<SkeletonLink href={`/lists/[id]`} as={`/lists/${c(list.linkRewrite)}`} >
							<a title={c("see-list")}>{list.name.replace(" | ", " ")}</a>
						</SkeletonLink>
						{index < recommenders.length - 1 ? ", " : ""}
					</Fragment>
				))}
			</p>
		</section>
	)
}
